<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-atom">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
<!-- <button type="button" (click)="openLoader()">show</button> -->
<router-outlet />